import { useEffect, useState } from 'react';

// A screen's period/year pick, remembered across refreshes and sessions (localStorage, per browser --
// same trade-off as ADR 0042). Month-end close runs past the 1st, so defaulting to today's month kept
// jumping to the new month mid-close (Judy, 2026-11-02). `initialValue` applies only the first time.
export function useRememberedPeriod(key, initialValue) {
  const storeKey = `psOpsHub.period.${key}`;
  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(storeKey);
      return stored !== null ? JSON.parse(stored) : initialValue;
    } catch {
      return initialValue;
    }
  });
  useEffect(() => {
    try { localStorage.setItem(storeKey, JSON.stringify(value)); } catch { /* private mode -- just won't persist */ }
  }, [storeKey, value]);
  return [value, setValue];
}
